/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2021, Bulb Inc.  For more information, please email contact@hellobulb.com.
 *
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
 *
 */

import {
  Component, HostListener, AfterViewInit, AfterViewChecked, ChangeDetectorRef, Inject,
} from '@angular/core';
import { MessageService } from 'primeng/api';
import { TranslationService } from '../../../common/translation.service';

/**
* Angular component that Notifies to the user that they are offline.
*/
@Component({
  selector: 'bulb-offline-notification',
  templateUrl: './offline-notification.component.html',
  styleUrls: ['./offline-notification.component.scss'],
  standalone: false,
})
export class OfflineNotificationComponent implements AfterViewInit, AfterViewChecked {
  /**
   * Text message for offline notification.
   */
  private offlineText: string = '';

  /**
   * Text message for online notification.
   */
  private onlineText: string = '';

  /**
   * It decides toast message visibility.
   */
  showMessage: boolean = false;

  constructor(
    private messageService: MessageService,
    private $translate: TranslationService,
    private cdr: ChangeDetectorRef,
    @Inject('BulbActivityService') private bulbActivityService : any,
  ) { }

  /**
   * ngAfterViewInit Life cycle hook to load the p-toast icons in background.
   */
  ngAfterViewInit() {
    this.showMessage = false;
    this.messageService.add({
      severity: 'success', detail: this.onlineText, closable: false,
    });
    this.showMessage = true;
  }

  /**
   * ngAfterViewChecked Life cycle hook to detect change after view is initialized.
   */
  ngAfterViewChecked() {
    this.cdr.detectChanges();
  }

  /**
   * Listen to offline event and notifies the user.
   */
  @HostListener('window:offline')
  public notifyNetworkOffline(): void {
    this.bulbActivityService.isOnline(false);
    this.offlineText = this.$translate.translateInstant('offline_indicator_code_header');
    this.messageService.add({
      severity: 'warn', detail: this.offlineText, closable: false, sticky: true,
    });
  }

  /**
  * Listen to online event and notifies the user.
  */
  @HostListener('window:online')
  public notifyNetworkOnline(): void {
    this.bulbActivityService.isOnline(true);
    this.messageService.clear();
    this.onlineText = this.$translate.translateInstant('online_indicator_code_header');
    this.messageService.add({
      severity: 'success', detail: this.onlineText, closable: false, life: 3000,
    });
  }
}
